import FlexBox from '@/atomic-components/FlexBox';
import { Box, Drawer, IconButton } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import CloseIcon from '@/assets/CloseIcon.svg';
import { useState } from 'react';
import OfferCodeInput from './OfferCodeInput';
import CouponCard from './CouponCard';
import { CART_TYPE, TCartOffers, TOffer } from '@/services/cart/models/cart';
import { useCart } from '@/hooks/useCart';
import { TAppliedCoupon } from '@/services/offers/get-offers';
import { SelectedOffer } from '../Cart/VerticalCart';
import OfferTile from '@/components/Cart/CartOffers/OfferTile';
import { getColor } from '@/utils/theme/colors';

type TOffersListProps = {
	enteredOfferCode: string;
	onCodeInput: (code: string) => void;
	offers: TCartOffers;
	cart?: any;
	visible: boolean;
	onClose: () => void;
	applyOfferToCart: (selectedOffer: SelectedOffer, cartType: any) => void;
	offerBeingApplied?: SelectedOffer;
	appliedOffer?: TAppliedCoupon;
	errorMessage?: string;
	onRemove?: (e: any) => void;
	removingCouponCode?: boolean;
	cartType?: CART_TYPE;
	hasApplicableOffers?: boolean;
	hasBankOffer?: boolean;
	hasNonApplicableOffers?: boolean;
	openTermConditions?: any;
	closeTermConditions?: any;
	isTermConditionsVisible?: boolean;
	offerClicked?: any;
};

const OffersList = (props: TOffersListProps) => {
	function applyEnteredCouponCode() {
		const offer = props.offers?.applicableOffers?.find(
			(offer) => offer.code === props.enteredOfferCode
		);

		props?.applyOfferToCart(
			{
				code: props.enteredOfferCode,
				id: offer?.id,
			},
			props.cartType
		);
	}

	function getSavingsText(offer: TOffer) {
		if (props.appliedOffer?.appliedCouponId === offer.id) {
			// actually saved
			return (
				<LencoTypography
					variant='Small_Regular'
					color={getColor('Success +1')}
					mb='8px'
				>
					Saved {props.appliedOffer?.appliedCouponSavings.displayValue}
				</LencoTypography>
			);
		} else if (offer?.savings.value > 0) {
			// potential saving
			return (
				<LencoTypography
					variant='Small_Regular'
					color={getColor('Success +1')}
					mb='8px'
				>
					Save {offer?.savings?.displayValue}
				</LencoTypography>
			);
		}
	}

	return (
		<>
			<Drawer anchor='right' open={props.visible} onClose={props.onClose}>
				<Box width='460px' p='10px 60px'>
					<FlexBox
						alignItems={'center'}
						justifyContent={'space-between'}
						mt='60px'
						mb='24px'
					>
						<LencoTypography variant='H11_Medium'>
							Offers and Discounts
						</LencoTypography>
						<IconButton
							onClick={
								props?.isTermConditionsVisible
									? props.closeTermConditions
									: props.onClose
							}
						>
							<CloseIcon />
						</IconButton>
					</FlexBox>
					<OfferCodeInput
						value={props.enteredOfferCode}
						onChange={props.onCodeInput}
						onSubmit={applyEnteredCouponCode}
						errorMessage={props.errorMessage}
						offerBeingApplied={props.offerBeingApplied}
					/>
					{props.hasApplicableOffers && (
						<Box mt='32px'>
							<LencoTypography>Offers for you</LencoTypography>
							{props.offers?.applicableOffers?.map((offer) => (
								<Box pt='14px' key={offer.id}>
									<OfferTile
										rentOffer={offer}
										isDrawer={true}
										offerClicked={props.offerClicked}
										isTermConditionsVisible={props?.isTermConditionsVisible}
										cartType={props.cartType}
										applyOfferToCart={props.applyOfferToCart}
										removingCouponCode={props.removingCouponCode}
										onRemove={props.onRemove}
										isApplied={
											props.cart?.appliedCoupon?.appliedCouponId === offer.id
										}
									/>
								</Box>
							))}
						</Box>
					)}
					{props.hasBankOffer && (
						<Box mt='32px'>
							<LencoTypography>Bank Offers</LencoTypography>
							{props.offers?.bankOffers?.map((offer) => (
								<Box mt='14px' key={offer.code}>
									<OfferTile
										isDrawer={true}
										rentOffer={offer}
										offerClicked={props.offerClicked}
										isTermConditionsVisible={props?.isTermConditionsVisible}
										cartType={props.cartType}
										applyOfferToCart={props.applyOfferToCart}
										removingCouponCode={props.removingCouponCode}
										onRemove={props.onRemove}
										isApplied={
											props.cart?.appliedCoupon?.appliedCouponId === offer.id
										}
									/>
								</Box>
							))}
						</Box>
					)}
					{props.hasNonApplicableOffers && (
						<Box mt='32px'>
							<LencoTypography>Other Offers</LencoTypography>
							{props.offers?.nonApplicableOffers?.map((offer) => (
								<Box mt='14px' key={offer.code}>
									<OfferTile
										isDrawer={true}
										rentOffer={offer}
										offerClicked={props.offerClicked}
										isTermConditionsVisible={props?.isTermConditionsVisible}
										isnonApplicableOffers={true}
										cartType={props.cartType}
										applyOfferToCart={props.applyOfferToCart}
										removingCouponCode={props.removingCouponCode}
										onRemove={props.onRemove}
										isApplied={
											props.cart?.appliedCoupon?.appliedCouponId === offer.id
										}
									/>
								</Box>
							))}
						</Box>
					)}
					{/* {props?.isTermConditionsVisible && <>dhwiuwfuwefwifbw</>} */}
				</Box>
			</Drawer>
		</>
	);
};

export default OffersList;
